
import { defineComponent, computed, getCurrentInstance } from "vue";
import { useRoute } from "vue-router";

import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "merchant-actions",
  components: {},
  emits: ["trigger-action"],
  setup(props, { emit }) {
    const route = useRoute();
    // eslint-disable-next-line
    const $vueInstance: any = getCurrentInstance();

    const getMerchantId = computed(() => {
      return route.params.id;
    });

    const onAPISync = async () => {
      emit("trigger-action", true);
      try {
        let res = await ApiService.get(
          `merchants/accounts/${getMerchantId.value}`
        );
        const { mid_number } = res.data.data[0];

        res = await ApiService.post(
          `chargebacks/incoming?action=sync_chargebacks&merchant_id=${getMerchantId.value}&mid_number=${mid_number}`,
          {}
        );
        if (res.data.success) {
          $vueInstance?.proxy?.$toast.success(
            "Chargebacks Successfully synced!",
            {
              duration: false,
              dismissible: false,
            }
          );
        } else {
          $vueInstance?.proxy?.$toast.error(res.data.error.message, {
            duration: false,
            dismissible: false,
          });
        }
      } catch (e) {
        $vueInstance?.proxy?.$toast.error(
          e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong with Sync Chargebacks!",
          {
            duration: false,
            dismissible: false,
          }
        );
      }
      emit("trigger-action", false);
    };

    return {
      onAPISync,
    };
  },
});
